import { ServerEndpoint } from '../Redux/endpoints.ts';
import { post } from './ApiService';
import { getCampaignParams } from '../Hooks/useUtmCapture';

const ContactService = {

  // --- Private Helper to ensure consistency ---
  async _dispatch(endpoint, data, source, subject, attachments = []) {
    const payload = {
      answers: data, // The actual form fields
      metadata: {
        source: source,
        subject: subject || `New Submission from ${source}`,
        campaign: getCampaignParams(), // UTM / click-id attribution for the lead source
      }
    };
    return await post(endpoint, payload, true, 'שולח נתונים...', attachments);
  },

  /**
   * Generic Form (PWA / Multi-step)
   */
  async submitForm(payload, attachments = []) {
    const body = {
      ...payload,
      metadata: { ...(payload.metadata || {}), campaign: getCampaignParams() },
    };
    return await post(ServerEndpoint.SUBMIT_FORM, body, true, 'שולח טופס...', attachments);
  },

  /**
   * Standard Contact Form
   */
  async sendContact(data) {
    return this._dispatch(
      ServerEndpoint.CONTACT,
      data,
      "Contact Form",
      // Prefer a caller-supplied subject (e.g. the clicked service) for the
      // notification subject line; fall back to a generic new-lead label.
      data.subject || `פנייה חדשה: ${data.fullName}`
    );
  },

  /**
   * Event Registration (quick lead to join an event)
   */
  async joinEvent(data) {
    return this._dispatch(
      ServerEndpoint.CONTACT,
      data,
      "Event Registration",
      `הרשמה לאירוע: ${data.eventTitle || ''}`
    );
  },

  /**
   * Project Quiz / Assessment
   */
  async sendQuiz(data) {
    return this._dispatch(
      ServerEndpoint.QUIZ,
      data,
      "Quiz/Assessment",
      `שאלון פרויקט: ${data.businessName || data.fullName}`
    );
  },

  /**
   * Product / Support Inquiry
   */
  async sendSupport(data) {
    return this._dispatch(
      ServerEndpoint.INQUIRY,
      data,
      "Support/Inquiry",
      `בירור שירות: ${data.subject}`
    );
  },

  /**
   * Service Agreement
   */
  async submitAgreement(agreementData) {
    return this._dispatch(
      ServerEndpoint.TERMS_HOSTING,
      agreementData,
      "Hosting Terms",
      "חתימה על הסכם שירות"
    );
  }
};

export default ContactService;